import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { IApplicationState } from '../store';

const useDocumentLocale = () => {
	const selectedLanguage = useSelector((state: IApplicationState) => state.intl.selectedLanguage);

	useEffect(() => {
		document.documentElement.lang = selectedLanguage.code ?? 'en';
		document.documentElement.dir = selectedLanguage.rtl ? 'rtl' : 'ltr';
	}, [selectedLanguage.code, selectedLanguage.rtl]);
};

export default useDocumentLocale;
